<template>
    <div class="k-view-two">
        <a v-if="link" :href="link?link:'javascript:;'" class="k-view-link"></a>
        <div class="k-view-two--lf">
            <img :src="img" class="k-view-two--img" alt="">
        </div>
        <div class="k-view-two--bd">
            <div class="k-view--title">{{title || ""}}</div>
            <div class="k-view--desc">{{desc || ""}}</div>
            <div v-if="tags" class="k-view--tag">
                <k-tag v-for="(item,index) in tags" :key="index" round color="#eee" text-color="#666">{{item}}</k-tag>
            </div>
        </div>
        <div v-if="price" class="k-view-two-rt" >
           <slot name="right">
           <div class="k-view--text ta-right">
               <div v-if="price" class="k-prd-price">{{price}}</div>
               <div v-if="amount" class="k-prd-num">&times;{{amount}}</div>
           </div>
           </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "k-view-two",
        props : ["img", "title", "tags", "desc", "link","price", "amount"]
    }
</script>

<style lang="less" scoped>
    .k-view-two {
        position: relative;
        padding: 0.2rem 0.3rem;
        font-size: 0.24rem;
        display: flex;
        &:after, &:before {
            content: "";
            display: table;
            clear: both;
            height: 0;
            line-height: 0;
        }
        .k-view-link {
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            height: 100%;
            width: 100%;
            z-index: 1;
        }
        .k-view-two--lf {
            margin-right: 0.2rem;
        }
        .k-view-two--bd {
            flex: 1;
        }
        .k-view-two--img {
            width: 1.2rem;
            height: 1.2rem;
            vertical-align:middle;
        }
        .k-view--title {
            font-size: 0.3rem;
            margin-bottom: 0.2rem;
        }
        .k-view--text {
            padding-top: 0.2rem;
        }
        .k-prd-price {
            font-size: 0.32rem;
            &:before{
                content: '¥';
                font-size: 0.2rem;
            }
        }
        .k-prd-num {
            color: #999;
        }
    }

</style>